<template>
    <div class="horn-item">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "horn-item",
    props: {
      width: {
        type: [Number, String],
        default: '100%'
      }
    },
  }
</script>

<style scoped lang="stylus">
    .horn-item {
        height 100%
        display inline-block
        white-space nowrap
        vertical-align middle
        &:after {
            width 0
            height 100%
            display inline-block
            content ""
            vertical-align middle
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/c-laba/mini-horn/horn-item.vue